import React, {useState, useEffect} from 'react'
import { FormInputSelect } from '../../../common/form'
import { fetchChains } from '../../../../modules/chains'

function RulesetChainSelect({type, chains, setChain, chain}) {
  switch(type) {
    case 'discount':
    case 'rebate':
    case 'def_rebate':
      return (
        <div className="mt-2">
          <FormInputSelect
            selected={chain}
            setSelected={setChain}
            options={chains}
            label="Select Chain"
          />
        </div>
      )
      break;
    default:
      return null;
  }
}

export default function NewRuleset({handleSave, handleCancel}) {
  const [rulesetType, setRulesetType] = useState(null);
  const [chain, setChain] = useState({});
  const [chains, setChains] = useState([]);
  const [effectiveAt, setEffectiveAt] = useState(null);

  useEffect(() => {
    fetchChains()
      .then((data) => {
        setChains(data);
      })
  }, [])

  function onSave() {
    handleSave({
      chain_id: chain.id,
      policy_type: rulesetType,
    })
  }

  return (
    <div className="mt-3">
      <hr />

      <div className="flex">
        <div>
          <label htmlFor="type" className="block text-sm font-normal text-gray-700 mt-2 mb-1">
            Select Type
          </label>
          <select
            id="type"
            name="type"
            className="
            focus:ring-teal-500 focus:border-teal-500
            col-start-1 row-start-1 appearance-none  rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 sm:text-sm/6
          "
            onChange={(e) => {
              setRulesetType(e.target.value)
            }}
          >
            <option>Please select type</option>
            <option value="discount">Discount</option>
            <option value="rebate">Rebate</option>
            <option value="def_rebate">DEF Rebate</option>
          </select>
        </div>
        <div className="ml-3">
          <RulesetChainSelect
            type={rulesetType}
            chains={chains}
            chain={chain}
            setChain={setChain}
          />
        </div>
      </div>

      <div className="mt-3">
        <button type="button"
                onClick={(e)=> {
                  e.preventDefault()
                  handleCancel()
                }}
                className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20">
          Cancel
        </button>

        <button type="button"
                onClick={(e) => {
                  e.preventDefault()
                  onSave()
                }}
                className="ml-3 rounded bg-indigo-50 px-2 py-1 text-sm font-semibold text-indigo-600 shadow-sm hover:bg-indigo-100 dark:bg-indigo-500/20 dark:text-indigo-400 dark:shadow-none dark:hover:bg-indigo-500/30">
          Add Ruleset
        </button>
      </div>
    </div>
  )
}
